/**
 * Output Restricted Media Key Status.
 *
 *
 * @beta
 */
export const OUTPUT_RESTRICTED = 'output-restricted'
